export default __webpack_public_path__ + "static/og_talk-5a8d9e27a2624416156c1f3f1491bcfa.png";